export enum AccessKey {
    settings = "settings"
}